"use strict";;define(function(require,exports,module){const _    = require('lodash');
const env  = require('lib/env');
const User = require('models/User');

module.exports = {
	SAML_ATTACHED_TIME_OUT : 2000,

	shouldAttachSAML : function(user, step, {
		hasSAML,
	} = {}) {

		if (!user.isInvited || step !== 0) {
			return false;
		}

		if (env.isFimEnabled) {
			// new auth
			if (_.isNil(hasSAML)) {
				throw new Error('hasSAML must be provided');
			}
			return !hasSAML && user.defaultAuthenticationProviderType === User.Authenticator.PROVIDER_TYPES.SAML2;
		}

		// roadmapping auth
		return user.hasMagicLinksForEvolution(User.Authenticator.MagicLink.EVOLUTIONS.SAML2) && !user.isSAML2Attached;
	},
};


});